module.exports = __webpack_public_path__ + "img/participant-fields-icon.b313aea0.svg";